<ng-container *transloco="let t">
<!--address, city-->
<address #addressComponent [address]="address"></address>
<div class="row mb-8">
  @if (!isHidden('asset.disposition')) {
    <div class="col-md-6 fv-row">
      <label class="form-label mb-2" [ngClass]="{'required': isRequired('asset.disposition')}">{{getLabel('asset.disposition', t('wizard.assets.pendingSale.disposition'))}}</label>
      <input class="form-control form-control-solid"
      [required]="isRequired('asset.disposition')"
      [ngClass]="{'is-invalid' : disposition && disposition.touched && disposition.invalid}"
      #disposition="ngModel" [(ngModel)]="asset!.disposition" placeholder="" name="disposition" />
    </div>
  }
  @if (!isHidden('asset.amountOfMortgageLien')) {
    <div class="col-md-6 fv-row">
      <label class="form-label mb-2" [ngClass]="{'required': isRequired('asset.amountOfMortgageLien')}">{{getLabel('asset.amountOfMortgageLien', t('wizard.assets.pendingSale.amountOfMortgageLien'))}}</label>
      <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
        [ngClass]="{'is-invalid' : amountOfMortageLien && amountOfMortageLien.touched && amountOfMortageLien.invalid}"
        [required]="isRequired('asset.amountOfMortgageLien')"
      #amountOfMortageLien="ngModel" [(ngModel)]="asset!.amountOfMortgageLien" placeholder="" name="amountOfMortageLien" />
      <div class="invalid-feedback">{{ t('wizard.assets.pendingSale.amountOfMortgageLienRequired') }}</div>
    </div>
  }
</div>
<div class="row mb-8">
  @if (!isHidden('asset.mortgagePayment')) {
    <div class="col-md-6 fv-row">
        <label class="form-label mb-2" [ngClass]="{'required': isRequired('asset.mortgagePayment')}">{{getLabel('asset.mortgagePayment', t('wizard.assets.pendingSale.mortgagePayment'))}}</label>
        <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
          [required]="isRequired('asset.mortgagePayment')"
          [ngClass]="{'is-invalid' : mortgagePayment && mortgagePayment.touched && mortgagePayment.invalid}"
          #mortgagePayment="ngModel" [(ngModel)]="asset!.mortgagePayment" placeholder="" name="mortgagePayment" />
    </div>
  }
  @if (!isHidden('asset.gross')) {
    <div class="col-md-6 fv-row">
        <label class="form-label mb-2" [ngClass]="{'required': isRequired('asset.gross')}">{{getLabel('asset.gross', t('wizard.assets.pendingSale.gross'))}}</label>
        <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
        [required]="isRequired('asset.gross')"
        [ngClass]="{'is-invalid' : gross && gross.touched && gross.invalid}"
        #gross="ngModel" [(ngModel)]="asset!.gross" placeholder="" name="gross" />
    </div>
  }
  </div>
  <div class="row mb-8">
    @if (!isHidden('asset.netRentalIncome')) {
      <div class="col-md-6 fv-row">
          <label class="form-label mb-2" [ngClass]="{'required': isRequired('asset.netRentalIncome')}">{{getLabel('asset.netRentalIncome', t('wizard.assets.pendingSale.netRentalIncome'))}}</label>
          <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
            [required]="isRequired('asset.netRentalIncome')"
            [ngClass]="{'is-invalid' : netRentalIncome && netRentalIncome.touched && netRentalIncome.invalid}"
            #netRentalIncome="ngModel" [(ngModel)]="asset!.netRentalIncome" placeholder="" name="netRentalIncome" />
      </div>
    }
    @if (!isHidden('asset.insMainTaxMisc')) {
      <div class="col-md-6 fv-row">
          <label class="form-label mb-2" [ngClass]="{'required': isRequired('asset.insMainTaxMisc')}">{{getLabel('asset.insMainTaxMisc', t('wizard.assets.pendingSale.insMainTaxMisc'))}}</label>
          <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
            [required]="isRequired('asset.insMainTaxMisc')"
            [ngClass]="{'is-invalid' : insMainTaxMisc && insMainTaxMisc.touched && insMainTaxMisc.invalid}"
            #insMainTaxMisc="ngModel" [(ngModel)]="asset!.insMainTaxMisc" placeholder="" name="insMainTaxMisc" />
      </div>
    }
    </div>
</ng-container>
